import styled from 'styled-components';

export const StyledUserInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 1.5rem;
    border: 1px solid #CBCBCB;
    width: 35%;
    padding: 1.75rem;
    justify-content: center;

    @media (max-width: 1480px) {
        width: 50%;
    }

    @media (max-width: 900px) {
        width: 100%;
        box-sizing: border-box;
    }
`

export const StyledUserInfoWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;
`

export const StyledUserProfileImage = styled.img`
    border-radius: 1rem;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border: 1px solid #000;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 6px 8px;
`

export const StyledUserInfo = styled.div`
    display: flex;
    flex-direction: column;
    width: 60%;
    justify-content: space-around;
    width: fit-content;
`

export const StyledWalletInfo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
`

export const StyledButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
`